import { fromJS } from 'immutable';

import {
  fetchTaskProfilesRoutine,
  fetchTaskProfileRoutine,
  saveTaskProfileRoutine,
  removeTaskProfileRoutine,
} from '../routines';
import { remove, updateOrAdd } from './helper';

const initialState = fromJS({
  taskProfiles: {},
  taskProfile: {},
  loading: true,
});

export default function (state = initialState, action) {
  switch (action.type) {
    case fetchTaskProfilesRoutine.SUCCESS:
      return state.set('taskProfiles', fromJS(action.payload.response));
    case fetchTaskProfilesRoutine.FAILURE:
      return state.setIn(['taskProfiles','loading'], false);

    case fetchTaskProfileRoutine.SUCCESS:
      return state.set('taskProfile', fromJS(action.payload.response));
    case fetchTaskProfileRoutine.FAILURE:
      return state.set('error', action.error).set('loading', false);

    case saveTaskProfileRoutine.SUCCESS:
      return state.updateIn(['taskProfiles','data'], updateOrAdd(fromJS(action.payload.response.data)));
    case removeTaskProfileRoutine.SUCCESS:
      return state.updateIn(['taskProfiles','data'], remove(fromJS(action.payload.request)));

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/redux/reducers/taskprofiles.js